import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

/* < ------------   Membership routes  ---------------- > */

// Membership registration
import MembershipRegistration from '../../pages/membership/membershipRegistration/membershipRegistration';

// Membership List
import MembershipList from '../membership/memberList/membershipList';

// Verify Membership
import VerifyMembership from '../membership/verifyMembership/verifyMembership';

// change membership Type
import ChangeMembershipTypeStep1 from '../membership/changeMembershipType/step1/selectCategory';
import ChangeMembershipTypeStep2 from '../membership/changeMembershipType/step2/payment';
import ChangeMembershipTypeSuccess from '../membership/changeMembershipType/success/success';

// renew Membership
import RenewMembership from '../../pages/membership/renewMembership/renewMembership';

// Verify Address
import VerifyAddressStep1 from '../membership/verifyAddress/step1/verifyAddress';
import VerifyAddressStep2 from '../membership/verifyAddress/step2/payment';
import VerifyAddressSuccess from '../membership/verifyAddress/success/succes';

// Membership Receipt
import MembershipReceipt from '../membership/receipts/receipts';

// Add A Family Member
import AddNewFamilyMember from '../membership/addNewFamilyMember/addFamilyMember';
import FamilyMemberCard from '../membership/addNewFamilyMember/familyCard';

// Change Membership Card
import ChangeCard from '../membership/changeCard/membershipCard';

// Membership Attendance
import MembershipAttendance from '../programs/memberAttendance/memberAttendance';

/* < -------------------------------   Programs routes  ------------------------------------- > */

import ProgramDetails from '../../pages/programs/programDetails/programDetails';
import ProgramsList from '../programs/programsList/programsList';

// Registration List
import RegistrationList from '../programs/registrationList/registrationList';

//Crate Attendees without registration
import AddAttendance from '../../pages/programs/addAttendance/addAttendance';
import CreateAttendance from '../programs/createAttendanceWithoutRegistration/createAttendanceWithoutRegistration';
import EditAttendance from '../programs/editAttendance/editAttendance';

// Program registration
import ProgramRegistration from '../../pages/programs/programRegistration/programRegistration';

// Registration Details
import RegistrationDetails from '../programs/registrationDetails/registrationDetails';

/* < -------------------------------   Reports routes  ------------------------------------- > */
import Reports from '../reports/reports';

// Receipts
import Receipts from '../reports/revenue/receipts';

// Covid19
import CheckInHistory from '../reports/covid19/checkInHistory/checkInHistory';
import UserHistory from '../reports/covid19/userHistory/userHistory';
import DailyCheckInList from '../reports/covid19/dailyCheckInList/dailyCheckInList';
import DailyCheckIn from '../reports/covid19/dailyCheckIn/dailyCheckIn';

// settings
import ProfileSettings from '../profile/profile';

const ReceptionistRoutes = function(userData) {
  return (
    <Switch>
      {/* Reports */}
      <Route path="/adminPortal/reports/dailyCheckIn/:dailyCheckInID/:backRoute" component={DailyCheckIn} />
      <Route path="/adminPortal/reports/dailyCheckInList" component={DailyCheckInList} />
      <Route path="/adminPortal/reports/checkInHistory/userHistory/:userID/:backRoute" component={UserHistory} />
      <Route path="/adminPortal/reports/checkInHistory" component={CheckInHistory} />
      <Route path="/adminPortal/reports/receipts" component={Receipts} />
      <Route path="/adminPortal/reports" render={(props) => <Reports {...props} userData={userData} />} />

      {/* Membership Registration Route */}
      <Route path="/adminPortal/membership/register" render={(props) => <MembershipRegistration {...props} userData={userData} />} />
      
      {/* Membership Routes */}
      <Route path="/adminPortal/membership/changeMembershipType/success" component={ChangeMembershipTypeSuccess} />
      <Route path="/adminPortal/membership/changeMembershipType/payment/:membershipID" component={ChangeMembershipTypeStep2} />
      <Route path="/adminPortal/membership/changeMembershipType/:membershipID" component={ChangeMembershipTypeStep1} />
      <Route path="/adminPortal/membership/verifyMembership/:membershipID" component={VerifyMembership} />
      <Route path="/adminPortal/membership/receipts/:membershipID" component={MembershipReceipt} />
      <Route path="/adminPortal/membership/verifyAddress/payment/:membershipID" component={VerifyAddressStep2} />
      <Route path="/adminPortal/membership/verifyAddress/success" component={VerifyAddressSuccess} />
      <Route path="/adminPortal/membership/verifyAddress/:membershipID" component={VerifyAddressStep1} />
      <Route path="/adminPortal/membership/addFamilyMember/:membershipID" component={AddNewFamilyMember} />
      <Route path="/adminPortal/membership/addFamilyMemberCard/:membershipID" component={FamilyMemberCard} />
      <Route path="/adminPortal/membership/changeCard/:membershipID" component={ChangeCard} />
      <Route path="/adminPortal/membership/renewMembership/:membershipID" render={(props) => <RenewMembership {...props} userData={userData} />} />

      {/* Programs Routes */}
      <Route path="/adminPortal/programs/registrationDetails/:programID/:membershipID/:familyMemberID" render={(props) => <RegistrationDetails {...props} userData={userData} />} />

      <Route path="/adminPortal/programs/createattendance/:programID" render={(props) => <CreateAttendance {...props} userData={userData} />}/>
      <Route path="/adminPortal/programs/editattendance/:programID/:attendeenceID" render={(props) => <EditAttendance {...props} userData={userData} />}/>
      <Route path="/adminPortal/programs/AddAttendance/:programID/:backPage?" render={(props) => <AddAttendance {...props} userData={userData} />} />
      
      <Route path="/adminPortal/programs/memberProgramAttendance/:membershipID/:programID" component={MembershipAttendance} />
      <Route path="/adminPortal/programs/programRegistration/:programID/:backPage?" render={(props) => <ProgramRegistration {...props} userData={userData} />} />
      <Route path="/adminPortal/programs/registrationList/:programID" render={(props) => <RegistrationList {...props} userData={userData} />} />
      <Route path="/adminPortal/programs/programDetails/:programID" render={(props) => <ProgramDetails {...props} userData={userData} />} />
      <Route path="/adminPortal/programs" render={(props) => <ProgramsList {...props} userData={userData} />} />

      {/* Profile */}
      <Route path="/adminPortal/profile" render={(props) => <ProfileSettings {...props} userData={userData} />} />

      <Route path="/adminPortal/membership" component={MembershipList} />
      <Route path="*" exact component={MembershipList} />
    </Switch>
  );
};

export default ReceptionistRoutes;

ReceptionistRoutes.propTypes = {
  userData: PropTypes.shape({
    userType: PropTypes.string,
  }).isRequired,
};
